import StudyEdit from './StudyEdit';

export default StudyEdit;